import axios from "axios";
import config from "../../config";

const SearchServices = {
  getDateRefinement(t, ourDay) {
    let currentDate = ourDay;
    currentDate.setHours(0, 0, 0, 0);
    let gmtTime = new Date(
      currentDate
        .toString()
        .substring(0, 29)
        .concat("0000")
    );
    let time = gmtTime.getTime();
    let day = gmtTime.getDay();
    switch (t) {
      case "all":
        return {
          dateRefinement: "All Dates",
          startDate: null,
          endDate: null
        };

      case "today":
        return {
          dateRefinement: "Today",
          startDate: time,
          endDate: time
        };

      case "tomorrow":
        return {
          dateRefinement: "Tomorrow",
          startDate: time + 86400000,
          endDate: time + 86400000
        };

      case "thisWeekend":
        return {
          dateRefinement: "This Weekend",
          startDate: time + (6 - day) * 86400000,
          endDate: time + (7 - day) * 86400000
        };

      case "thisWeek":
        return {
          dateRefinement: "This Week",
          startDate: time - (day - 1) * 86400000,
          endDate: time + (7 - day) * 86400000
        };

      case "nextWeek":
        return {
          dateRefinement: "Next Week",
          startDate: time + (8 - day) * 86400000,
          endDate: time + (14 - day) * 86400000
        };
    }
  },

  getAreaFromLatLng(lat, lng) {
    return axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${config(
        "GOOGLE_API_KEY"
      )}`
    );
  }
};

export default SearchServices;
